type Cookies = {
    [key: string]: Cookie
}

export type Cookie = {
    Name: string
    Value: string
    HttpOnly?: boolean
    Secure?: boolean
    SameSite?: 'Strict' | 'Lax' | 'None'
    Expires?: string
    MaxAge?: string
    Domain?: string
    Path?: string
}

export function parseSetCookies(cookies: string[] | string): Cookies {
    if (!Array.isArray(cookies)) {
        cookies = [cookies]
    }

    return Object.fromEntries(
        cookies
            .filter((str) => !!str)
            .map(parseCookie)
            .map((c) => [c.Name, c])
    )
}

export function parseCookies(header: string): Record<string, string> {
    return header
        .split(';')
        .map((str) => str.trim().split(/=(.+)/))
        .reduce(
            (acc, curr) => {
                if (curr[0] && curr[1]) {
                    acc[curr[0]] = curr[1]
                }
                return acc
            },
            {} as Record<string, string>
        )
}

function parseCookie(c: string): Cookie {
    const values = c.split(';').filter((v) => !!v)
    const [cookiePair, ...pairs] = values.map((p) => p.split('='))

    return {
        Name: (cookiePair && cookiePair[0]?.trim()) || '',
        Value: ((cookiePair && cookiePair[1]) || '').trim(),
        ...Object.fromEntries(
            pairs.reduce(
                (acc, pair) => {
                    if (!pair[0]) {
                        return acc
                    }

                    const key = pair[0].trim()

                    if ('Max-Age' === pair[0]) {
                        return [...acc, ['MaxAge', pair[1] || 0]]
                    }

                    if ('SameSite' === key) {
                        const val = pair[1] || ''

                        if (val[0] === undefined) {
                            return acc
                        }

                        return [
                            ...acc,
                            [
                                'SameSite',
                                `${val[0].toUpperCase()}${val
                                    .slice(1)
                                    .toLowerCase()}`,
                            ],
                        ]
                    }

                    if (!pair[1]) {
                        return [...acc, [key, true]]
                    }

                    return [...acc, [key, pair[1] || '']]
                },
                [] as [string, string | number | boolean][]
            )
        ),
    }
}
